<template>
  <div class="form" v-loading='loading'>
    <el-form :label-position="labelPosition" label-width="140px" :model="form" style="padding-bottom: 35px;">


      <el-form-item :label="$t('message.table.versionNumber') + ':'" v-if="baseId == 101" required>
        <el-select v-model="version" :placeholder="$t('message.placeholder.search')" size="mini" style="width:100%"
          @change="setPage">
          <el-option v-for="item in versionList" :key="item.id" :label="item.text" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>

      <!-- <el-form-item :label="'是否生成图号' + ':'" v-if="baseId == 101" required>
         <el-select v-model="num"  :placeholder="$t('message.placeholder.search')" size="small" style="width:100%">
          <el-option v-for="item in numList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item :label="'是否继承BOM' + ':'" v-if="baseId == 101" required>
        <!-- <el-input v-model="form.name" size="small" ></el-input> -->
        <el-select v-model="inherit" :placeholder="$t('message.placeholder.search')" size="mini" style="width:100%">
          <el-option v-for="item in inheritList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <div v-if="!loading">
        <div v-for="(item, index) in pageInfo" :key="index">
          <PageEdit :page="item" ref="PageEdit" :pageIndex="index" :checkReq.sync="item.req">
          </PageEdit>
        </div>
      </div>

      <el-form-item style="float:right;margin-bottom: 25px;">
        <el-button type="primary" @click="submitForm" size="small">{{
          $t("message.button.submit")
        }}</el-button>
        <el-button @click="cancel" type="success" size="small">{{
          $t("message.button.cancel")
        }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from "axios";
import { baseInfo } from "@/utils/publicstate";
export default {
  data() {
    return {
      labelPosition: "right",
      form: {
        subClassId: "",
        // name: "",
      },
      version: '',
      // editName:'',
      options: [],
      autoNumber: false,

      pageInfo: [],
      objectId: { ...this.$store.state.objectId },
      pageOrder: [this.$t("message.title.pageOne"), this.$t("message.title.pageTwo"), this.$t("message.title.pageThree")],
      getUrl: {},

      num: 0,
      inherit: 0,

      numList: [
        { value: 1, label: this.$t('message.table.yes') },
        { value: 0, label: this.$t('message.table.no') },
        { value: 2, label: this.$t('message.table.relatedOldDoc') },
      ],
      inheritList: [
        { value: 2, label: this.$t('message.table.yes') },
        { value: 0, label: this.$t('message.table.no') },
        // { value: 2, label: '继承旧BOM' },
      ],
      loading: false
    };
  },
  components: {
    PageEdit: () => import("./page/pageEditforDialog.vue"),
  },
  props: ["versionList"],
  computed: {
    // autoNumber() {
    //   return !this.form.subClassId;
    // },
    subClassChanged() {
      return this.form.subClassId != this.objectId.subClassId;
    },
    editName() {
      return this.autoNumber ? this.$t('message.title.autoNumber') : this.$t('message.tips.inputName')
    }
  },
  methods: {
    getSubClass() {
      // let baseId = this.objectId.classId.toString().substr(0, 3);
      axios
        .get('pmdm/admin/cls/getSubClses?clsId=' + this.objectId.classId)
        .then((res) => {
          this.options = res.data.object.subClses.map((i) => ({ value: i.id, label: i.name, autoNumber: i.autoNumber != -1 }));
          this.autoNumber = this.options.find(i => i.value == this.form.subClassId).autoNumber
        });
    },
    getAutoNumber() {
      // this.form.name = '';
      axios.get('/pmdm/admin/autonumber/getNextNumber?subClsId=' + this.form.subClassId).then(res => {
        this.autoNumber = !!res.data.object.nextNumber;
        // this.editName = this.autoNumber ? '编号自动生成' : '请输入名称'
      })
    },



    submitForm() {

      const list = ['pageOne', 'pageTwo', 'pageThree'];
      // return
      const pageObj = {};
      this.$refs.PageEdit.map((i, e) => {
        const { pageData, subData } = i
        const { ids } = this.pageInfo[e].column;
        const obj = {};
        ids.map((j, idx) => {
          let val = pageData[idx];
          if (Array.isArray(pageData[idx])) {
            val = pageData[idx].join(';')
          }
          val !== "" && (obj[j] = val)
        })
        pageObj[list[e]] = { ...obj, ...subData, classId: this.objectId.classId }
      })
      if (!(this.version + '')) {
        this.$message.error(this.$t('message.warning.required'));
        return
      }
      const { id, classId } = this.objectId
      const obj = {
        name: '',
        ...this.form,
        currentId: id,
        ...pageObj,
        currentChangeId: this.version,
        copyImage: this.num,
        createBOM: this.inherit
      }

      axios.post(`/pmdm/items/getInsertItemInfo`, obj).then(res => {

        const { ItemDescErrList } = res.data.object;
        if (!ItemDescErrList.length) {
          this.submit(obj);
        } else {
          ItemDescErrList.unshift(this.$t('message.tips.duplicateObject'));
          const strs = ItemDescErrList.join('<br>')
          this.$confirm(strs, { type: 'warning', dangerouslyUseHTMLString: true, }).then(res => {
            this.submit(obj)
          }).catch(_ => {
          })
        }
      })

    },

    submit(obj) {
      axios.post('/pmdm/items/saveAsItem', obj).then(res => {
        this.$emit('close')
        if (res.data.code == 200) {
          const item = {
            ...res.data.object,
            name: res.data.object.name
          }
          this.getLink(item);
        }
      })
    },
    cancel() {
      this.$emit('close')
    },
    async getData(e) {
      const { data } = await axios.get(this.getUrl.loadTable, { params: e })
      return data;
    },
    setPage() {
      this.getTitleBlockInfo()
    },
    getTitleBlockInfo() {
      this.loading = true

      const changeInfo = this.versionList.find(i => i.id === this.version);
      const { id: changeId, classId: changeClassId, subClassId: changeSubClassId } = changeInfo
      // const change_info = this.$store.state.change_info;
      // const {id,classId,subClassId} = this.objectId;
      const baseId = parseInt(this.objectId.classId.toString().substr(0, 3));

      this.getUrl = baseInfo.find(i => i.id == baseId);

      const pageList = new Array(3).fill("_").map((i, e) => {
        const obj = {
          ... this.objectId,
          changeId, changeClassId, changeSubClassId,
          tableId: e + 1
        };
        return this.getData(obj)
      });
      Promise.all(pageList)
        .then(res => {
          this.pageInfo = res.map((i, e) => {
            const { columnInfo, rows } = i.object.table
            const obj = {
              column: columnInfo,
              val: rows[0],
              name: this.pageOrder[e]
            }
            return obj
          })

          // if (baseId === 101) {
          //   const [p1, p2, p3] = res;
          //   this.remindModifyCodeAttributes = baseId == 101 && (p2.object.needRemind || p3.object.needRemind)
          //   const xx = !p3.object.remindAttrList.length ? p2.object.remindAttrList : p3.object.remindAttrList;
          //   this.codeAttributes = [...xx]
          // }

        }).finally(_ => {
          this.loading = false
        })


    },
  },
  created() {
    this.baseId = this.objectId.classId.toString().substr(0, 3);
    this.form.subClassId = this.objectId.subClassId;
    this.getSubClass();
    this.version = this.versionList[0]?.id
    this.getTitleBlockInfo();
  },

};
</script>

<style scoped>
.form {
  padding: 25px 60px;
  height: 600px;
  overflow: auto
}

.warning-title {

  font-size: 12px;
  margin: -25px 0 20px 112px;
  color: #e6a23c;
  /* height: ; */
}

.warning {
  color: #e6a23c;
  font-size: 14px;
}
</style>
